(function () {
  function openPreferences() {
    try {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return;
      }
    } catch (error) {}

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        try {
          if (window.privacyBanner && window.privacyBanner.showPreferences) {
            window.privacyBanner.showPreferences();
          }
        } catch (error) {}
      });
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('a[href*="#cookie-preferences"], [data-cookie-prefs]')
      : null;

    if (!target) return;

    event.preventDefault();
    openPreferences();
  });

  function injectFooterIcon() {
    if (document.querySelector('.hb-cookie-fab')) return;

    var footer = document.querySelector('.site-footer, footer, [data-section-type*="footer"], .footer');
    if (!footer) return;
    var footerInner = footer.querySelector('.page-width') || footer;
    footer.classList.add('hb-footer--has-cookie-fab');

    if (!document.getElementById('hb-cookie-fab-footer-style')) {
      var style = document.createElement('style');
      style.id = 'hb-cookie-fab-footer-style';
      style.textContent = '@media (max-width: 768px){.hb-footer--has-cookie-fab{padding-bottom:calc(var(--hb-cookie-fab-footer-padding-bottom, 42px) + env(safe-area-inset-bottom, 0px));}}';
      document.head.appendChild(style);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'hb-cookie-fab';
    button.setAttribute('aria-label', 'Cookie settings');
    button.title = 'Cookie settings';
    button.innerHTML = [
      '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32" aria-hidden="true">',
      '<path d="M0 0h32v32H0z" fill="none"/>',
      '<g fill="currentColor">',
      '<path d="m20.51 8.36l-.62-.04c-.52-.04-1.01-.33-1.24-.83c-.38-.77-.04-1.71.76-2.05a1.51 1.51 0 0 1 1.85.59c.13.22.21.47.22.71l.04.61a.95.95 0 0 1-1.01 1.01m6.45 5.63l-.04.62c-.04.52-.33 1.01-.83 1.24c-.77.38-1.71.04-2.05-.76a1.51 1.51 0 0 1 .59-1.85c.22-.13.47-.21.71-.22l.61-.04a.95.95 0 0 1 1.01 1.01m-16.29 9.76l-.05.77c-.05.71.54 1.3 1.25 1.25l.76-.05c.3-.02.6-.11.88-.28a1.87 1.87 0 0 0 .73-2.3a1.85 1.85 0 0 0-2.54-.94c-.62.31-.99.91-1.03 1.55m9.76-9.02l-.03.46a2.87 2.87 0 0 1-1.62 2.43c-1.51.75-3.36.08-4.01-1.51a2.93 2.93 0 0 1 1.22-3.62c.42-.25.87-.38 1.32-.4l.45-.03a2.514 2.514 0 0 1 2.67 2.67M7.68 9.42L7.65 9c-.08-1.37 1.05-2.51 2.42-2.42l.41.03c.41.02.82.14 1.2.36c1.13.66 1.6 2.08 1.11 3.29a2.656 2.656 0 0 1-3.64 1.37c-.88-.44-1.41-1.3-1.47-2.21m16.6 13.76l-.02-.36c-.05-.79-.5-1.52-1.26-1.88a2.27 2.27 0 0 0-3.12 1.17c-.42 1.03-.02 2.24.95 2.81c.33.19.68.29 1.03.31l.35.02c1.17.08 2.15-.9 2.07-2.07M5.91 17.54l-.04-.62a.95.95 0 0 1 1.01-1.01l.61.04c.24.01.49.09.71.22c.62.39.87 1.18.59 1.85c-.34.8-1.28 1.14-2.05.76c-.5-.23-.8-.72-.83-1.24"/>',
      '<path d="M16 1C11.952 1 8.19 2.16 5.429 4.671C2.65 7.197 1 10.985 1 16c0 4.883 1.656 8.664 4.423 11.219C8.177 29.76 11.937 31 16 31c4.064 0 7.824-1.247 10.578-3.793C29.344 24.649 31 20.869 31 16c0-4.95-1.653-8.734-4.426-11.274C23.816 2.2 20.055 1 16 1M3 16c0-4.555 1.484-7.767 3.774-9.849C9.08 4.054 12.318 3 16 3c3.675 0 6.914 1.085 9.223 3.201C27.518 8.304 29 11.52 29 16c0 4.392-1.479 7.61-3.78 9.738C22.906 27.878 19.666 29 16 29s-6.907-1.116-9.22-3.251C4.48 23.626 3 20.407 3 16"/>',
      '</g>',
      '</svg>'
    ].join('');
    button.style.cssText = 'display:flex;align-items:center;justify-content:center;margin:10px auto 0;width:40px;height:40px;border-radius:50%;border:1px solid var(--colorBtnPrimary,#111);background:var(--colorBtnPrimary,#111);color:var(--colorBtnPrimaryText,#fff);cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.12);padding:0;';
    button.addEventListener('click', function () {
      openPreferences();
    });

    footerInner.appendChild(button);
  }

  if (document.readyState !== 'loading') {
    injectFooterIcon();
  } else {
    document.addEventListener('DOMContentLoaded', injectFooterIcon);
  }
})();
